import { render, staticRenderFns } from "./TaskCaption.vue?vue&type=template&id=17f0a7c9&scoped=true"
import script from "./TaskCaption.vue?vue&type=script&lang=js"
export * from "./TaskCaption.vue?vue&type=script&lang=js"
import style0 from "./TaskCaption.vue?vue&type=style&index=0&id=17f0a7c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f0a7c9",
  null
  
)

export default component.exports